import { PessoaService } from '../../pessoa.service';
import { PrestadorServico } from './../prestadorServico';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-prestador-servico-detail',
  	templateUrl: './prestadorServicoDetail.component.html',
  	styleUrls: ['./prestadorServicoDetail.component.scss']
})

export class PrestadorServicoDetailComponent implements OnInit{
	
	@ViewChild('Swal') public swal:SwalComponent; 
	public message:string = '';
	detailForm: FormGroup;
	prestadorServico: PrestadorServico;
	prestador_id:number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	contasBancarias:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(private pessoaService: PessoaService, private activatedRoute: ActivatedRoute,private formBuilder: FormBuilder){
		this.detailForm = this.formBuilder.group({
			id: this.formBuilder.control(0),
			estrangeiro: this.formBuilder.control(''),
			tipo: this.formBuilder.control(''),
			passaporte: this.formBuilder.control(''),
			passaporte_dt_validade: this.formBuilder.control(''),
			cpf: this.formBuilder.control(''),
			cnpj: this.formBuilder.control(''),
			dt_cadastro: this.formBuilder.control(''),
			dt_atualizacao: this.formBuilder.control(''),
			dt_nascimento: this.formBuilder.control(''),
			primeiro_nome: this.formBuilder.control(''),
			ultimo_nome: this.formBuilder.control(''),
			apelido: this.formBuilder.control(''),
			nome_completo: this.formBuilder.control(''),
			email: this.formBuilder.control(''),
			nacionalidade: this.formBuilder.control(''),
			naturalidade: this.formBuilder.control(''),
			status: this.formBuilder.control('A'),
			genero_id: this.formBuilder.control(''),
			genero: this.formBuilder.control(''),
			rg: this.formBuilder.control(''),
			rg_dt_emissao: this.formBuilder.control(''),
			rg_emissor: this.formBuilder.control(''),
			rg_uf: this.formBuilder.control(''),
			observacao: this.formBuilder.control(''),
			website: this.formBuilder.control(''),
			estado_civil: this.formBuilder.control(''),
			estado_civil_id: this.formBuilder.control(''),
			pis: this.formBuilder.control(''),
			grau_instrucao_id: this.formBuilder.control(''),
			grau_instrucao: this.formBuilder.control(''),
			nome_pai: this.formBuilder.control(''),
			nome_mae: this.formBuilder.control(''),
			razao_social: this.formBuilder.control(''),
		});	
		this.prestador_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/prestador-servico',this.prestador_id).subscribe(
		(prestadorServico) => {
			this.prestadorServico = prestadorServico.dados;
			this.pessoa_id = this.prestadorServico.pessoa_id;
			this.acesso = this.prestadorServico.acesso;
			if(this.prestadorServico.foto){
				this.thumb = this.prestadorServico.foto.thumb;
			}

			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.contasBancarias = success.dados.conta_bancaria;
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})


				this.detailForm.patchValue({
					id: this.prestadorServico.id,
					estrangeiro: this.prestadorServico.estrangeiro,
					tipo: this.prestadorServico.tipo,
					passaporte: this.prestadorServico.passaporte,
					passaporte_dt_validade: this.prestadorServico.passaporte_dt_validade_br,
					cpf: this.prestadorServico.cpf,
					cnpj: this.prestadorServico.cnpj,
					dt_cadastro: this.prestadorServico.dt_cadastro_br,
					dt_atualizacao: this.prestadorServico.dt_atualizacao_br,
					genero_id: this.prestadorServico.genero_id,
					genero: this.prestadorServico.genero,
					primeiro_nome: this.prestadorServico.primeiro_nome,
					ultimo_nome: this.prestadorServico.ultimo_nome,
					nome_completo: this.prestadorServico.nome_completo,
					apelido: this.prestadorServico.apelido,
					email: this.prestadorServico.email,
					rg: this.prestadorServico.rg,
					rg_uf: this.prestadorServico.rg_uf,
					rg_dt_emissao: this.prestadorServico.rg_dt_emissao_br,
					rg_emissor: this.prestadorServico.rg_emissor,
					foto: this.thumb,
					observacao: this.prestadorServico.observacao,
					dt_nascimento: this.prestadorServico.dt_nascimento_br,
					status: this.prestadorServico.status,
					website: this.prestadorServico.website,
					estado_civil: this.prestadorServico.estado_civil,
					estado_civil_id: this.prestadorServico.estado_civil_id,
					pis: this.prestadorServico.pis,
					grau_instrucao_id: this.prestadorServico.grau_instrucao_id,
					grau_instrucao: this.prestadorServico.grau_instrucao,
					nome_pai: this.prestadorServico.nome_pai,
					nome_mae: this.prestadorServico.nome_mae,
					razao_social: this.prestadorServico.razao_social,
				});
			})
		}

	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_prestador.includes("CONSULTAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
	
	
}